import React, { useEffect, useState } from "react";
import { api } from "../../services/apiClient";
import { handleError } from "../../services/erros/ErrorHandler";

import "./style.css";

/**
 * Card de notícia do Portal — desde 2026-09-15 é só imagem.
 *
 * Antes havia duas variantes (Texto e Imagem) e o card mostrava título e data. Passou a ser um
 * banner puro: o título continua existindo no cadastro do Raptor, mas só como identificação
 * interna e texto alternativo da imagem. Quem cadastra é Raptor > Cadastros > Notícias do Portal.
 */
const Noticia = ({ id, anexo_id: anexoId, identificacao }) => {
  const [imagemUrl, setImagemUrl] = useState(null);

  useEffect(() => {
    if (!anexoId) return undefined;

    let cancelado = false;
    let urlCriada = null;

    const buscarImagem = async () => {
      try {
        const response = await api.get(`/noticia/imagem/${anexoId}`, { responseType: "blob" });
        if (cancelado || !response?.data) return;
        urlCriada = URL.createObjectURL(response.data);
        setImagemUrl(urlCriada);
      } catch (error) {
        handleError(error, "Erro ao Baixar Imagem");
      }
    };

    buscarImagem();

    // Sem o revoke, cada recarregamento da Home deixava o blob anterior preso na memória da aba.
    return () => {
      cancelado = true;
      if (urlCriada) URL.revokeObjectURL(urlCriada);
    };
  }, [anexoId]);

  if (!imagemUrl) return null;

  return (
    <div className="noticia">
      <img className="noticia-imagem" src={imagemUrl} alt={identificacao || "Informação"} />
    </div>
  );
};

export default Noticia;
